exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pageTitle[data-v-598ab2d9] {\n    margin-bottom: 2em;\n}\n", ""]);

// exports
